var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTheta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 11,
    viewBox: "0 0 7 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.552 10.12C2.896 10.12 2.352 9.936 1.92 9.568C1.496 9.192 1.18 8.66 0.972 7.972C0.764 7.276 0.66 6.444 0.66 5.476C0.66 4.5 0.756 3.664 0.948 2.968C1.14 2.272 1.448 1.74 1.872 1.372C2.304 1.004 2.864 0.819999 3.552 0.819999C4.216 0.819999 4.764 1.004 5.196 1.372C5.628 1.732 5.948 2.26 6.156 2.956C6.372 3.652 6.48 4.492 6.48 5.476C6.48 6.444 6.38 7.276 6.18 7.972C5.988 8.66 5.676 9.192 5.244 9.568C4.82 9.936 4.256 10.12 3.552 10.12ZM3.552 9.244C3.968 9.244 4.308 9.124 4.572 8.884C4.844 8.644 5.048 8.268 5.184 7.756C5.32 7.244 5.396 6.576 5.412 5.752H1.728C1.744 6.568 1.812 7.232 1.932 7.744C2.06 8.256 2.256 8.636 2.52 8.884C2.784 9.124 3.128 9.244 3.552 9.244ZM1.728 4.936H5.4C5.376 4.208 5.296 3.608 5.16 3.136C5.024 2.656 4.824 2.3 4.56 2.068C4.296 1.828 3.96 1.708 3.552 1.708C3.144 1.708 2.808 1.828 2.544 2.068C2.288 2.3 2.096 2.656 1.968 3.136C1.84 3.608 1.76 4.208 1.728 4.936Z",
    fill: "white",
    fillOpacity: 0.64
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheta);
export default __webpack_public_path__ + "static/media/theta.73b6f39602a69ecb9d41aea6a23d65d4.svg";
export { ForwardRef as ReactComponent };